import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//UI
import { Form, Message } from "semantic-ui-react";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import "semantic-ui-css/semantic.min.css";
import "../../../styles/common.css";
//ACTIONS
import { createVoucher } from "../../../../redux/actions/reservations/voucher/createVoucher";
import { initialStateVoucher } from "../../../../redux/actions/reservations/voucher/fetchVoucher";
import { updateVoucher } from "../../../../redux/actions/reservations/voucher/updateVoucher";
import { fetchPassengers, initialStatePassenger } from "../../../../redux/actions/reservations/passenger/fetchPassengersByAgency";
import { fetchVoucherFormCustom, initialStateVoucherFormCustom, updateVoucherPassengers } from "../../../../redux/slices/custom/reservations/cruise/voucher/customVoucherForm.slice";
//RESOURCES
import HeadDetail from "../../../../components/headDetail";
import { scrollToTop } from "../../../resources/utils";

const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "10%",
    marginTop: -12,
    marginLeft: -82,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
}));

export default function VoucherForm() {
  const classes = useStyles();
  let history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { cruise_id } = useParams();
  let { voucher_id } = useParams();
  const { register, handleSubmit, errors } = useForm();
  let start_date_format;
  let end_date_format;
  let agencies = [];
  const voucherStateCustom = useSelector((state) => state.customVoucherForm);
  const voucherState = useSelector((state) => state.voucherReducer);
  const passengerByAgencyState = useSelector((state) => state.passengerByAgencyReducer);
  const [servicesIncluded, setServicesIncluded] = useState();
  const [active, setActive] = useState(false);
  const [passengers, setPassengers] = useState([]);
  const [isDirect, setIsDirect] = useState(false);
  let newPassengers = [];
  const [notIncluded, setNotIncluded] = useState(`- Migratory card $20 per person
- Galapagos National Park Entrance Fee $200 per person
- Bottled and alcoholic drinks
- Wetsuit (only available under previous request, service must be paid aboard in cash only)
- Personal expenses
- Tips
- Travel insurance
    `
  );
  const [remark, setRemark] = useState(
    `Please be present at National departures gate in (Quito/Guayaquil) airport  at (12:00 a.m.) on (Month/Day/Year).
Your flight (Airline and flight number) is scheduled to depart at (12:00 a.m.)
A representative from our office, (First Name / Last Name), will meet you at the (AVIANCA counter) at (12:00 a.m). His/Her mobile number is (phone number).
Kindly ensure that you bring your original passport, migratory card, as well as other needed travel documents as it is required for check-in and boarding procedures.
Emergency contact number: (number)
This document constitutes the sole valid authorization for boarding.`
  );

  useEffect(() => {
    dispatch(fetchVoucherFormCustom(voucher_id, cruise_id))
    scrollToTop();
    return () => {
      dispatch(initialStateVoucherFormCustom());
      dispatch(initialStateVoucher());
      dispatch(initialStatePassenger())
    };
  }, [dispatch, cruise_id, voucher_id]);

  useEffect(() => {
    if (voucher_id && Object.keys(voucherStateCustom.voucher).length !== 0 && voucherStateCustom.passengers.length > 0) {
      const agency = agencies.find(agency => agency.agency_id === voucherStateCustom.voucher.agency_id)
      if (agency.agency_direct) {
        setIsDirect(true)
      } else {
        setIsDirect(false)
      }
    }
  }, [voucher_id, voucherStateCustom.voucher, voucherStateCustom.passengers]);

  if (voucherStateCustom.fetching || voucherState.fetching) {
    return <CircularProgress />;
  }

  function formatDate(inputDate) {
    if (inputDate) {
      return inputDate.split("/").reverse().join("-");
    }
  }

  if (voucherStateCustom.cruise.start_date_format) {
    start_date_format = formatDate(voucherStateCustom.cruise.start_date_format)
  }

  if (voucherStateCustom.cruise.end_date_format) {
    end_date_format = formatDate(voucherStateCustom.cruise.end_date_format)

  }

  voucherStateCustom.reservations.forEach((reservation) => {
    agencies.push({
      agency_id: reservation.agency_id,
      agency_name: reservation.agency_name,
      agency_direct: reservation.agency_direct,
    });
  });

  const handleAgencyId = (agency_id) => {
    const agency = agencies.find(agency => agency.agency_id === agency_id)
    if (agency.agency_direct) {
      setIsDirect(true)
    } else {
      setIsDirect(false)
    }
    dispatch(fetchPassengers(cruise_id, agency_id));
  };

  if (voucherStateCustom.passengers.length > 0) {
    const currentPassengers = voucherStateCustom.passengers;
    const selected = voucherStateCustom.voucherPassengers;

    newPassengers = currentPassengers.map((passenger) => {
      const isSelected = selected.some((p) => p.passenger_id === passenger.id);
      return {
        ...passenger,
        active: isSelected
      };
    });
  }

  const handleCheck = (passengerId, checked) => {
    if (checked) {
      setPassengers(prev => [...prev, { passenger_id: passengerId }]);
    } else {
      handleUncheck(passengerId, checked);
    }
  };

  const handleUncheck = (passengerId, check) => {
    const currentPassengers = [...voucherStateCustom.voucherPassengers];

    if (check === false) {
      const updated = currentPassengers.filter(pass => pass.passenger_id !== passengerId);
      dispatch(updateVoucherPassengers(updated));
    } else {
      // Por si se vuelve a marcar el checkbox
      const passenger = passengers.find(p => p.passenger_id === passengerId);
      const exists = currentPassengers.some(p => p.passenger_id === passengerId);
      if (!exists && passenger) {
        dispatch(updateVoucherPassengers([...currentPassengers, passenger]));
      }
    }
  };

  const onSubmit = (data) => {
    data = {
      ...data,
      passengers: [...passengers, ...voucherStateCustom.voucherPassengers],
    };

    if (voucher_id) {
      dispatch(updateVoucher(voucher_id, data));
    } else {
      dispatch(createVoucher(cruise_id, data));
    }
    setServicesIncluded(servicesIncluded);
    setNotIncluded(notIncluded);
    setRemark(remark);
  };

  if (
    voucherState.message === "resource created successfully" ||
    voucherState.message === "resource updated successfully"
  ) {
    history.push(`/cruises/${cruise_id}/vouchers`);
  }

  if (voucherStateCustom.cruise.yacht_code && servicesIncluded === undefined) {
    setServicesIncluded(`- Flight ticket to Galapagos     
- Cruise aboard (nombre del barco)
- Full board during the cruise
- Permanent drink water station aboard    
- Shore excursions escorted by an English-speaking guide
- Transfers between islands during the cruise
- Snorkel gear (snorkel, fins, mask)
- Kayaks
- WiFi`);
  }

  return (
    <>
      {voucherState.error ? (
        <Message negative content={t(voucherState.error)} />
      ) : (
        ""
      )}
      <div className="ui breadcrumb">
        <Link to={`/cruises/${cruise_id}/cruise-detail`}>
          <div className="active section">{voucherStateCustom.cruise.code}</div>
        </Link>
        <div className="divider">/</div>
        <Link to={`/cruises/${cruise_id}/vouchers`}>
          <div className="active section">{t("voucher_title")}</div>
        </Link>
        <div className="divider">/</div>
        <div className="active section">{t("voucher_path")}</div>
      </div>
      <br />
      <br />
      <br />
      <HeadDetail
        yacht_name={voucherStateCustom.cruise.yacht_name}
        itinerary_name={voucherStateCustom.cruise.itinerary_name}
        cruise_name={voucherStateCustom.cruise.name}
        start_date={voucherStateCustom.cruise.start_date_format}
        end_date={voucherStateCustom.cruise.end_date_format}
      />
      <br />
      <br />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.root}>
          <label>{t("general_information_tag")}</label>
          <br />
          <Divider variant="fullWidth" />
          <br />
          <Form.Group widths="equal">
            <Form.Field>
              <label>
                {t("voucher_startDate")}{" "}
                <span className="text_date_format">(dd-mm-yyyy)</span>
              </label>

              <input
                type="date"
                name="start_date"
                defaultValue={
                  voucher_id
                    ? formatDate(voucherStateCustom.voucher.start_date_format)
                    : start_date_format
                }
                ref={register}
              />
            </Form.Field>
            <Form.Field>
              <label>
                {t("voucher_endDate")}{" "}
                <span className="text_date_format">(dd-mm-yyyy)</span>
              </label>

              <input
                type="date"
                name="end_date"
                defaultValue={
                  voucher_id
                    ? formatDate(voucherStateCustom.voucher.end_date_format)
                    : end_date_format
                }
                ref={register}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field required>
              <label>{t("voucher_itinerary")}</label>
              <input
                placeholder="Itinerario"
                name="itinerary"
                defaultValue={
                  voucher_id
                    ? voucherStateCustom.voucher.itinerary
                    : voucherStateCustom.cruise.itinerary_name
                }
                ref={register({ required: true })}
              />
              {errors.itinerary && (
                <span className="error_message">
                  {t("required_information")}
                </span>
              )}
            </Form.Field>
            <Form.Field required>
              <label>{t("voucher_agency")}</label>
              <select
                name="agency_id"
                defaultValue={voucherStateCustom.voucher.agency_id}
                ref={register({ required: true })}
                onChange={(event) => handleAgencyId(event.target.value)}
              >
                <option></option>
                {agencies.map((agency, index) => (
                  <option
                    className="selected item"
                    key={index}
                    value={agency.agency_id}
                  >
                    {agency.agency_name}
                  </option>
                ))}
              </select>
              {errors.agency_id && (
                <span className="error_message">
                  {t("required_information")}
                </span>
              )}
            </Form.Field>
          </Form.Group>
          {isDirect && (
            <Form.Group widths="equal">
              <Form.Field required={isDirect}>
                <label>{t("A nombre de")}</label>
                <select
                  name="passenger_direct"
                  defaultValue={voucherStateCustom.voucher.passenger_direct}
                  ref={register({ required: isDirect })}
                >
                  <option></option>
                  {voucher_id && voucherStateCustom.passengers.length > 0 ?
                    newPassengers.map((passenger, index) => (
                      <option
                        className="selected item"
                        key={index}
                        value={passenger.last_name + ' ' + passenger.first_name}
                      >
                        {passenger.last_name + ' ' + passenger.first_name}
                      </option>

                    )) :
                    passengerByAgencyState.passengers.map((passenger, index) =>
                    (
                      <option
                        className="selected item"
                        key={index}
                        value={passenger.last_name + ' ' + passenger.first_name}
                      >
                        {passenger.last_name + ' ' + passenger.first_name}
                      </option>
                    ))
                  }
                </select>
                {errors.agency_id && (<span className="error_message">{t("required_information")}</span>)}
              </Form.Field>
            </Form.Group>
          )}
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("voucher_included")}</label>
              <textarea
                rows={3}
                placeholder="Services Included"
                name="included"
                ref={register}
                defaultValue={voucher_id ? voucherStateCustom.voucher.included : servicesIncluded}
              ></textarea>
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("voucher_notIncluded")}</label>
              <textarea
                rows={3}
                placeholder="Not Included"
                name="notIncluded"
                ref={register}
                defaultValue={
                  voucher_id ? voucherStateCustom.voucher.notIncluded : notIncluded
                }
              ></textarea>
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("voucher_wetsuits")}</label>
              <textarea
                rows={3}
                placeholder={t("voucher_wetsuits")}
                name="wetsuitsRental"
                ref={register}
                defaultValue={voucherStateCustom.voucher.wetsuitsRental}
              ></textarea>
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <label>{t("voucher_remarks")}</label>
            <textarea
              rows={4}
              placeholder="Remarks"
              name="remarks"
              ref={register}
              defaultValue={
                voucher_id !== undefined ? voucherStateCustom.voucher.remarks : remark
              }
            ></textarea>
          </Form.Field>

          <label>
            {t("voucher_passenger")}
            {voucherStateCustom.fetching === true ? (
              <CircularProgress size={17} color="primary" />
            ) : (
              ""
            )}
          </label>
          <Divider variant="fullWidth" />
          <br />
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>{t("voucher_lastName")}</TableCell>
                  <TableCell>{t("voucher_name")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {voucher_id &&
                  voucherStateCustom.passengers.length > 0
                  ? newPassengers.map((passenger, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="ui checkbox">
                          <input
                            type="checkbox"
                            name="active"
                            defaultChecked={passenger.active}
                            onChange={(event) => {
                              setActive(event.target.checked);
                              handleCheck(passenger.id, event.target.checked);
                              handleUncheck(passenger.id, event.target.checked);
                            }}
                          />
                          <label></label>
                        </div>
                      </TableCell>
                      <TableCell>{passenger.last_name}</TableCell>
                      <TableCell>{passenger.first_name}</TableCell>
                    </TableRow>
                  ))
                  : passengerByAgencyState.passengers.map((passenger, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="ui checkbox">
                          <input
                            type="checkbox"
                            name="active"
                            defaultChecked={active}
                            onChange={(event) => {
                              setActive(event.target.checked);
                              handleCheck(passenger.id, event.target.checked);
                              handleUncheck(passenger.id, event.target.checked);
                            }}
                          />
                          <label></label>
                        </div>
                      </TableCell>
                      <TableCell>{passenger.last_name}</TableCell>
                      <TableCell>{passenger.first_name}</TableCell>
                    </TableRow>
                  )
                  )}
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          <br></br>
          <Divider variant="middle" />
          <br></br>

          <Link to={`/cruises/${cruise_id}/vouchers`}>
            <button type="button" className="ui button">
              {t("canceled_button")}
            </button>
          </Link>

          <button
            type="submit"
            className={
              voucherStateCustom.processing
                ? "ui loading primary button"
                : "ui primary button"
            }
          >
            {t("save_button")}
          </button>
        </div>
      </Form>
    </>
  );
}
